<template>
  <b-modal
    modal-class="component-modal-product"
    id="catagoryItemModal"
    ref="catagoryItemModal"
    size="lg"
    :title="modalTitle"
    no-close-on-backdrop
    @close="close"
  >
    <b-form id="catagoryTable" @submit.prevent="saveCatagory">
      <b-form-group label-cols="3" label="รหัสหมวดหมู่:" label-align="right">
        <b-form-input
          class="required"
          id="catagoryCode"
          v-model="catagoryItem.catagoryCode"
          :class="{ 'is-invalid': $v.catagoryItem.catagoryCode.$error }"
          maxlength="20"
          placeholder="กรอกรหัสของหมวดหมู่สินค้า"
        ></b-form-input>
        <template v-slot:description> </template>
      </b-form-group>

      <b-form-group label-cols="3" label="ชื่อหมวดหมู่:" label-align="right">
        <b-form-input
          class="required"
          id="catagoryNameTh"
          v-model="catagoryItem.catagoryNameTh"
          :class="{ 'is-invalid': $v.catagoryItem.catagoryNameTh.$error }"
          maxlength="100"
          placeholder="กรอกชื่อหมวดหมู่ภาษาไทย"
        ></b-form-input>
        <template v-slot:description> </template>
      </b-form-group>

      <b-form-group
        label-cols="3"
        label="ชื่อหมวดหมู่ (Eng):"
        label-align="right"
      >
        <b-form-input
          id="catagoryNameEn"
          maxlength="100"
          v-model="catagoryItem.catagoryNameEn"
          placeholder="กรอกชื่อหมวดหมู่ภาษาอังกฤษ"
        ></b-form-input>
        <template v-slot:description> </template>
      </b-form-group>
    </b-form>

    <template v-slot:modal-footer>
      <b-button
        v-if="!isNewCatagory"
        variant="danger"
        @click="deleteCatagory(catagoryItem)"
        >ลบรายการ</b-button
      >
      <b-button type="submit" form="catagoryTable" variant="primary">
        {{ isNewCatagory ? "สร้างรายการ" : "แก้ไขรายการ" }}
      </b-button>
    </template>
    <Dialog ref="Dialog"></Dialog>
    <Loading v-if="isLoading"></Loading>
  </b-modal>
</template>

<script>
import Dialog from "@/components/modal/Dialog";
import Loading from "@/components/Loading";
import "@/theme/modal/ProductAndStock/Product.scss";
import { maxLength, required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import "@/theme/modal/Package.scss";

export default {
  name: "CatagoryCreateModal",
  components: {
    Dialog,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      modalTitle: "รายการหมวดหมู่สินค้า",
      isNewCatagory: true,
      catagoryItem: {
        catagoryId: "",
        catagoryCode: "",
        catagoryNameTh: "",
        catagoryNameEn: "",
      },
    };
  },
  validations: {
    catagoryItem: {
      catagoryCode: {
        required,
        maxLength: maxLength(20),
      },
      catagoryNameTh: {
        required,
        maxLength: maxLength(100),
      },
      catagoryNameEn: {
        maxLength: maxLength(100),
      },
    },
  },
  computed: {
    ...mapGetters({
      getCatagoryList: "moduleCatagoryMaster/getCatagoryList",
    }),
  },
  methods: {
    ...mapActions({
      fetchCatagoryList: "moduleCatagoryMaster/fetchCatagoryList",
    }),
    show(data) {
      if (data) {
        this.isNewCatagory = false;
        this.catagoryItem = Object.assign({}, data);
      } else {
        this.isNewCatagory = true;
        this.setDefaultValue();
      }
      this.$bvModal.show("catagoryItemModal");
    },
    close() {
      this.$v.$reset();
      this.setDefaultValue();
      this.isNewCatagory = true;
      this.$bvModal.hide("catagoryItemModal");
    },
    reloadCatagoryList() {
      this.fetchCatagoryList({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
      });
    },
    setDefaultValue() {
      this.catagoryItem = Object.assign(
        {},
        {
          catagoryCode: "",
          catagoryNameTh: "",
          catagoryNameEn: "",
        }
      );
    },
    saveCatagory() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.isLoading = true;

      const adjustCatagoryItem = {
        code: this.catagoryItem.catagoryCode,
        description: this.catagoryItem.catagoryNameTh,
        description2: this.catagoryItem.catagoryNameEn,
      };

      if (this.isNewCatagory) {
        this.$store
          .dispatch("moduleCatagoryMaster/createCatagoryItem", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            adjustCatagoryItem,
          })
          .then(res => {
            if (res.status == 201) {
              this.reloadCatagoryList();
              this.close();
              this.$parent.showDialogToast(
                "success",
                "เพิ่มรายการหมวดหมู่สินค้าสำเร็จ"
              );
            }
            this.close();
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;

            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "เพิ่มรายการหมวดหมู่สินค้าไม่สำเร็จ กรุณาลองใหม่";

            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$store
          .dispatch("moduleCatagoryMaster/updateCatagoryItem", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            adjustCatagoryItem,
            id: this.catagoryItem.catagoryId,
          })
          .then(res => {
            if (res.status == 200) {
              this.reloadCatagoryList();
              this.close();
              this.$parent.showDialogToast(
                "success",
                "แก้ไขรายการหมวดหมู่สินค้าสำเร็จ"
              );
            }
            this.close();
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;

            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "แก้ไขรายการหมวดหมู่สินค้าไม่สำเร็จ กรุณาลองใหม่";

            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    deleteCatagory(eventData) {
      this.$refs.Dialog.showAlertConfirm(
        "ลบหมวดหมู่สินค้านี้ ?",
        "คุณต้องการลบหมวดหมู่สินค้านี้ใช่หรือไม่"
      ).then(result => {
        if (!result.value) return;
        this.$store
          .dispatch("moduleCatagoryMaster/deleteCatagoryItem", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            id: this.catagoryItem.catagoryId,
          })
          .then(res => {
            if (res.status == 200) {
              this.reloadCatagoryList();
              this.close();
              this.$parent.showDialogToast(
                "success",
                "ลบรายการหมวดหมู่สินค้าสำเร็จ"
              );
            }
            this.close();
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;

            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "ลบรายการหมวดหมู่สินค้าไม่สำเร็จ กรุณาลองใหม่";

            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
  },
};
</script>
